
import { Vue, Component, Watch } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'
import Steps from './Steps.vue'
import StepOne from './StepOne.vue'
import StepOtherOne from './StepOtherOne.vue'
import StepTwo from './StepTwo.vue'
import StepThree from './StepThree.vue'
import { queryCompanyInfo } from '@/service/step-three'

@Component({
  components: { Steps, StepOne, StepTwo, StepThree, StepOtherOne },
})
export default class Authentication extends Vue {
  @State userInfo!: any
  @Action fetchLogout!: Function

  step = 0
  components = ['StepOne', 'StepTwo', 'StepThree', 'StepOtherOne']
  data: any = {
    company_name: '',
    license_address: '',
    business_license: '',
    person_name: '',
    person_idcard: '',
    person_mobile: '',
    finance_contacts: '',
    finance_contacts_phone: '',
    bank_account: '',
    bank_simple_name: '',
    person_card_type: '',
  }
  steps = ['确认认证信息', '银行验资', '认证成功']

  @Watch('userInfo', { immediate: true })
  updateSelected() {
    if (this.userInfo.need_upgrade === 1) {
      this.steps = ['结算账户补充认证', '认证成功']
      this.components = ['StepOtherOne', 'StepThree']
    }
  }

  created() {
    this.initData()
  }

  async initData() {
    const data = await queryCompanyInfo()
    Object.keys(this.data).forEach((key) => {
      this.data[key] = data[key]
    })
  }

  doLogout() {
    this.fetchLogout(() => {
      this.$message.success('已退出登录')
      this.$router.push({ path: '/' })
    })
  }
}
